import React, { Fragment, useEffect, useState } from "react";
import { Alert, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ArrowBack, MenuBook } from "@mui/icons-material";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../../firebase";
import { useUser } from "../context/UserContext";

const CreateTract = () => {
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [date, setDate] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { userRole, loading: roleLoading } = useUser();

  useEffect(() => {
    if (!roleLoading && userRole === "operator") {
      navigate("/home");
    }
  }, [roleLoading, userRole, navigate]);

  const handleCreate = async () => {
    if (!title) return setErrorMsg("Title cannot be empty");
    if (!link) return setErrorMsg("Link cannot be empty");
    if (!date) return setErrorMsg("Date cannot be empty");

    setLoading(true);
    try {
      await addDoc(collection(db, "sbc-tracts"), {
        title,
        link,
        date,
        createdAt: serverTimestamp(),
      });

      const userName = auth.currentUser?.email || "Admin";
      await addDoc(collection(db, "notifications"), {
        name: userName,
        message: `Added SBC Tract: ${title}`,
        createdAt: serverTimestamp(),
      });

      toast("Tract added successfully!", { type: "success" });
      setTimeout(() => navigate("/sbc-tracts"), 2000);
    } catch (err) {
      setErrorMsg(err.message || "Failed to add tract");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="min-h-screen bg-[#f5f7fe] p-3 sm:p-6">
        <div className="max-w-2xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <button
              onClick={() => navigate("/sbc-tracts")}
              className="p-2 rounded-xl hover:bg-white border border-transparent hover:border-gray-100 transition"
            >
              <ArrowBack className="text-gray-400" style={{ fontSize: 20 }} />
            </button>
            <div>
              <h1 className="text-xl sm:text-2xl font-bold text-[#000C66] font-aref">Add SBC Tract</h1>
              <p className="text-gray-400 text-xs font-abel mt-0.5">Add a new SBC tract with link</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-8">
            {errorMsg && <Alert severity="error" className="mb-5" onClose={() => setErrorMsg("")}>{errorMsg}</Alert>}

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 font-abel">Tract Title *</label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => { setTitle(e.target.value); setErrorMsg(""); }}
                  placeholder="e.g., The Four Spiritual Laws"
                  className="w-full px-4 py-3 border border-gray-200 rounded-xl font-abel text-sm text-gray-700 focus:outline-none focus:border-[#000C66] focus:ring-2 focus:ring-[#000C66]/10 transition"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 font-abel">Tract Link *</label>
                <input
                  type="url"
                  value={link}
                  onChange={(e) => { setLink(e.target.value); setErrorMsg(""); }}
                  placeholder="https://..."
                  className="w-full px-4 py-3 border border-gray-200 rounded-xl font-abel text-sm text-gray-700 focus:outline-none focus:border-[#000C66] focus:ring-2 focus:ring-[#000C66]/10 transition"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 font-abel">Date *</label>
                <input
                  type="date"
                  value={date}
                  onChange={(e) => { setDate(e.target.value); setErrorMsg(""); }}
                  className="w-full px-4 py-3 border border-gray-200 rounded-xl font-abel text-sm text-gray-700 focus:outline-none focus:border-[#000C66] focus:ring-2 focus:ring-[#000C66]/10 transition"
                />
              </Grid>

              <Grid item xs={12} className="flex justify-end">
                <button
                  onClick={handleCreate}
                  disabled={loading}
                  className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[#000C66] text-white px-8 py-3 rounded-xl font-abel font-semibold hover:bg-blue-900 transition disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : (
                    <MenuBook style={{ fontSize: 18 }} />
                  )}
                  {loading ? "Adding..." : "Add Tract"}
                </button>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CreateTract;
